import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Zap, ArrowLeft, CheckCircle } from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Error');
      }
      setSent(true);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: 'var(--bg-primary)' }}>
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: 'var(--accent-primary)' }}>
              <Zap size={22} className="text-white" />
            </div>
            <span className="text-xl font-heading font-bold" style={{ color: 'var(--text-primary)' }}>SalesAI</span>
          </div>
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Recuperar contraseña</p>
        </div>

        <div className="rounded-xl border p-6" style={{ backgroundColor: 'var(--surface-primary)', borderColor: 'var(--border-color)' }}>
          {sent ? (
            <div className="text-center py-4">
              <CheckCircle size={40} className="mx-auto mb-3 text-green-400" />
              <h3 className="font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>Email enviado</h3>
              <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
                Si el email existe en nuestro sistema, recibiras instrucciones para restablecer tu contraseña.
              </p>
              <Link to="/login" className="inline-block mt-4 text-sm font-medium" style={{ color: 'var(--accent-primary)' }}>
                Volver al login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-5">
              {error && (
                <div className="p-3 rounded-lg text-sm bg-red-500/10 text-red-400 border border-red-500/20">{error}</div>
              )}
              <div>
                <label className="block text-xs font-medium mb-1.5" style={{ color: 'var(--text-secondary)' }}>Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email"
                  className="w-full px-4 py-2.5 rounded-lg border text-sm outline-none"
                  style={{ backgroundColor: 'var(--surface-secondary)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
                  placeholder="tu@email.com"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-btn"
                className="w-full py-2.5 rounded-lg text-sm font-semibold text-white flex items-center justify-center gap-2"
                style={{ backgroundColor: 'var(--accent-primary)' }}
              >
                {loading ? <Loader2 size={16} className="animate-spin" /> : null}
                Enviar instrucciones
              </button>
              <div className="text-center">
                <Link to="/login" className="text-xs font-medium flex items-center justify-center gap-1" style={{ color: 'var(--text-muted)' }}>
                  <ArrowLeft size={12} /> Volver al login
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
